import React from 'react';
import { useIntl } from 'react-intl';
import clsx from "clsx";
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import { WHITE } from '../../utils/constants';
import Calendar from '../datepicker/calendar';

const useStyles = makeStyles(theme => ({
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    section1: {
      margin: theme.spacing(5, 0, 2.5, 0),
    }, 
    divider: {
        margin: theme.spacing(0, 0, 3, 0),
        backgroundColor: 'rgb(16, 40, 66)',
        height: 2
    },
    paper: {
        padding: theme.spacing(1.3),
        textAlign: 'center',
        color: 'rgb(144, 158, 187)',
        whiteSpace: 'nowrap',
        width: 120,
        fontWeight: 600,
        fontSize: 16,
        backgroundColor: 'rgb(11, 36, 62)'
      },
    firstOfTitle: {
        padding: theme.spacing(0, 3, 0, 0),
        letterSpacing: 0.05,
        fontWeight: 600,
        color: 'rgb(173, 185, 215)'
    }, 
    lastPaperTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(1.3, 1.2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        width: 150,
        borderRadius: 10,
        backgroundColor: '#2592EA'
    }, 
    livePaper: {
        padding: 1,
        textAlign: 'center',
        color: 'rgb(255, 255, 255)',
        whiteSpace: 'nowrap',
        width: 50,
        backgroundColor: 'rgb(37, 146, 234)',
    },
    hour: {
        fontWeight: 550,
        color: 'rgb(225, 226, 231)',
        fontSize: 17,
        padding: theme.spacing(0, 1)
    },
    whiteTheme: {
        backgroundColor: WHITE
    }, 
    whiteMode: {
        color: '#000',
    },
    themeLastPaperTitle: {
        backgroundColor: '#2592EA',
    },
    themeHour: {
        color:'rgb(255, 255, 255)'
    },
    livePaperFR: {
        width: 180
    },
    lastPaperTitleFR: {
        width: 220
    },
    times: {
        padding: theme.spacing(0, 3, 0, 0),
        letterSpacing: 0.05,
        color: 'rgb(173, 185, 215)',
        fontSize: 32
    }, 
  }));


const SubHeader = (props) => {
    const { title, isMode=false, theme, open= false, times=null, forms=null } = props;
    const classes = useStyles();
    const { formatMessage } = useIntl();
    const lang = localStorage.getItem('lang');

    return (
        <div>
            <div className={classes.section1}>
                <Grid container alignItems="center" justify="space-between">
                    <Box display="flex" width={650} justifyContent="space-between">
                        <Typography 
                            variant="h4" 
                            classes={{root: clsx(classes.firstOfTitle, !theme ? classes.whiteMode : null)}}
                        >
                            {title ? title : formatMessage({id:"app.subHeader.dashboard.bigTitle", defaultMessage: "Monday, 21 st October"})}
                        </Typography>
                        {
                            times &&
                            <Typography variant="h4" classes={{root: clsx(classes.times, !theme ? classes.whiteMode : null)}} >
                                {times}
                            </Typography>
                        }
                        {isMode &&
                            <Paper 
                                elevation={0}
                                classes={{root: clsx(classes.paper, !theme ? classes.whiteTheme : null)}}
                            >{formatMessage({id:"app.subHeader.dashboard.mode", defaultMessage: "TV mode"})}</Paper>
                        }
                    </Box>
                    <Box display="flex">
                        {
                            forms && <Calendar />
                        }
                        {/* <Typography variant="h4" classes={{root: clsx(classes.firstOfTitle, !theme ? classes.whiteMode : null)}} >
                            {propsForm && <Calendar />}
                        </Typography> */}
                        <Paper 
                            elevation={0}
                            classes={{root: clsx(classes.lastPaperTitle, !theme ? classes.themeLastPaperTitle : null, (lang === 'FR') && classes.livePaperFR)}}
                        >
                            <Typography 
                                classes={{root: clsx(classes.hour, !theme ? classes.themeHour : null)}}
                            >
                                {formatMessage({id:"app.subHeader.dashboard.week", defaultMessage: "This week"})}
                            </Typography>
                            <Box display="flex">
                                <img 
                                src={
                                    open
                                    ? `${process.env.PUBLIC_URL}/icons/uparrow.svg`
                                    : `${process.env.PUBLIC_URL}/icons/upsidedownarrow.svg`
                                    } 
                                alt="icon" 
                                style={{color: "#FFF"}}
                                />
                            </Box>
                        </Paper>
                    </Box>
                </Grid>
            </div>
            <Divider 
                variant="middle" 
                className={classes.divider} 
                light={true} 
                style={!theme ? {backgroundColor: '#D4DBE3'} : null}
            />
        </div>
    )
}

export default SubHeader;